import { assert } from './logger.js';
import { ws } from './ws.js';

/**
 * A base class for server sync classes.
 */
class AppSyncBase {
  constructor() {
    assert(
      this.pipeType && this.pipeType != 'unknown',
      `[ws] wrong ${this.pipeType} pipe type in ${this.constructor.name}`
    );
  }

  connect(pipeId) {
    if (this.pipeId) {
      this.disconnect();
    }

    this.pipeId = pipeId;
    ws.register(this.pipeType, this);
    return this.send('connect');
  }

  disconnect() {
    ws.unregister(this.pipeType);
    return this.send('disconnect');
  }

  shutdown() {
    this.disconnect();
    ws.shutdownIfNoPipes();
  }

  send(messageType) {
    return ws.send({
      messageType,
      pipeType: this.pipeType,
      pipeId: this.pipeId,
    });
  }

  get messages() {
    return {
      connected: 'connected',
    };
  }

  get pipeType() {
    return 'unknown';
  }
}

export { AppSyncBase };
